<template>
    <div class="row">
        <div class="col position-relative px-0 mb-3">
            <p class="m-0 text-white px-2 py-1" style="background-color: #292929;">
                Center Month at a Glance
            </p>
            <div class="d-flex">
                <div
                    v-for="i in 6"
                    @click="selectedStatus = i - 1"
                    :class="{ 'group-active': selectedStatus === i - 1 }"
                    class="group-count d-flex flex-column justify-content-center align-items-stretch flex-grow-1 p-2"
                    style="flex-basis: 16.66%; cursor:pointer;"
                >
                    <h4 class="text-center">
                        {{
                            i === 1
                                ? alerts.filter(a => a.status < 4).length
                                : alerts.filter(a => a.status === i - 1).length
                        }}
                    </h4>
                    <p class="group-description text-center">{{ statusList[i - 1] }}</p>
                </div>
            </div>
        </div>
        <center-month-alert
            v-for="(a, i) in selectedStatus
                ? alerts.filter(a => a.status === selectedStatus)
                : alerts"
            :alert="a"
            :key="i"
        ></center-month-alert>
    </div>
</template>
<script>
import CenterMonthAlert from "./CenterMonthAlert";

export default {
    name: "CenterMonthWidget",
    components: { CenterMonthAlert },
    data() {
        return {
            statusList: [
                "All Alerts",
                "High Alerts",
                "Medium Alerts",
                "Low Alerts",
                "Pending",
                "Resolved",
            ],
            selectedStatus: 0,
            alerts: [
                {
                    status: 2,
                    category: "Staff",
                    sub_category: "Overtime",
                    user: "Maria Mendez",
                    message: "is in overtime by 6 hours",
                    assigned_to: "You",
                    alert_started: "2018-02-28",
                    alert_due: "2018-03-02",
                },
                {
                    status: 3,
                    category: "Staff",
                    sub_category: "Overtime",
                    user: "Maria Mendez",
                    message: "is in overtime by 6 hours",
                    assigned_to: "You",
                    alert_started: "2018-02-28",
                    alert_due: "2018-03-02",
                },
                {
                    status: 4,
                    category: "Staff",
                    sub_category: "Overtime",
                    user: "Maria Mendez",
                    message: "is in overtime by 6 hours",
                    assigned_to: "You",
                    alert_started: "2018-02-28",
                    alert_due: "2018-03-02",
                },
                {
                    status: 5,
                    category: "Staff",
                    sub_category: "Overtime",
                    user: "Maria Mendez",
                    message: "is in overtime by 6 hours",
                    assigned_to: "You",
                    alert_started: "2018-02-28",
                    alert_due: "2018-03-02",
                },
                {
                    status: 1,
                    category: "Staff",
                    sub_category: "Overtime",
                    user: "Maria Mendez",
                    message: "is in overtime by 6 hours",
                    assigned_to: "You",
                    alert_started: "2018-02-28",
                    alert_due: "2018-03-02",
                },
                {
                    status: 2,
                    category: "Staff",
                    sub_category: "Overtime",
                    user: "Maria Mendez",
                    message: "is in overtime by 6 hours",
                    assigned_to: "You",
                    alert_started: "2018-02-28",
                    alert_due: "2018-03-02",
                },
                {
                    status: 5,
                    category: "Staff",
                    sub_category: "Overtime",
                    user: "Maria Mendez",
                    message: "is in overtime by 6 hours",
                    assigned_to: "You",
                    alert_started: "2018-02-28",
                    alert_due: "2018-03-02",
                },
                {
                    status: 4,
                    category: "Staff",
                    sub_category: "Overtime",
                    user: "Maria Mendez",
                    message: "is in overtime by 6 hours",
                    assigned_to: "You",
                    alert_started: "2018-02-28",
                    alert_due: "2018-03-02",
                },
            ],
        };
    },
    methods: {
        fetchCenterMonthGlance() {
            let endpoint = "";
            axios.post(endpoint).then(r => {
                this.alerts = r.data.alerts;
            });
        },
    },
};
</script>
<style scoped lang="scss">
.group-count {
    background-color: #edeced;
    color: #8f8f8f;
    border: solid 1px #8f8f8f;
}
.group-active {
    background-color: white !important;
    color: black !important;
    box-shadow: inset 0 -3px 0 #ac3f5d;
}
.group-description {
    font-size: 60%;
}

@media screen and (min-width: 768px) {
    .group-description {
        font-size: 80%;
    }
}
</style>
